export default __webpack_public_path__ + "assets/sierraleone-flag.png";